import {
  Component,
  OnInit,
  Input,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { MatDialog } from '@angular/material/dialog';
import { ScreenType } from 'src/app/enums/ScreenType';
import { IRiskHeatMap } from 'src/app/models/riskProfile';
import { AumyeGoogleMapLoadService } from 'src/app/services/aumye-google-map-load.service';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';

@Component({
  selector: 'app-incident-heat-map',
  templateUrl: './incident-heat-map.component.html',
  styleUrl: './incident-heat-map.component.scss',
})
export class IncidentHeatMapComponent implements OnInit {
  @Input() set heatMapAssetData(val: IRiskHeatMap[]) {
    if (val) {
      this.heatMapGraphData = val;
      this.setHeatMapGraphData();
    }
  }
  screenSize: ScreenType;
  ScreenType = ScreenType;
  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;
  infoWindowContent = 'This is me';
  constructor(
    private googleMapsLoader: AumyeGoogleMapLoadService,
    private dialog: MatDialog,
    private screen: AumyeResponsiveScreenService
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  isLoaded = false;
  heatMapGraphData: IRiskHeatMap[];
  selectedHeatMapData: IRiskHeatMap | null = null;
  ngOnInit(): void {
    this.initMap();
  }
  initMap() {
    this.googleMapsLoader
      .load()
      .then(() => {
        // this.heatmapData = this.generateRandomHeatmapData(20); // Generate 20 random data points
        this.isLoaded = true;
      })
      .catch((error) => {
        console.error('Error loading Google Maps API:', error);
      });
  }
  center = { lat: 28.6139, lng: 77.2088 };
  zoom = 20;
  heatmapData: any;
  heatmapOptions = {
    radius: 25,
    opacity: 0.9,
  };
  heatmapWeight: any;
  @ViewChild(GoogleMap, { static: false }) googleMap!: GoogleMap;
  @ViewChild('DetailsDialog', { static: true }) detailsDialog: TemplateRef<any>;
  setHeatMapGraphData() {
    if (this.isLoaded) {
      const data: any = [];
      const bounds = new google.maps.LatLngBounds();
      this.heatMapGraphData.forEach((x) => {
        const location = new google.maps.LatLng(x.latitude, x.longitude);
        data.push({
          location: new google.maps.LatLng(x.latitude, x.longitude),
          weight: x.incidentCount,
        });
        bounds.extend(location);
      });
      this.heatmapData = data;
      if (this.heatMapGraphData.length > 0) {
        setTimeout(() => {
          if (this.googleMap) {
            this.googleMap.fitBounds(bounds);
          }
        }, 2000);
      }
    } else {
      setTimeout(() => {
        this.setHeatMapGraphData();
      }, 2000);
    }
  }
  getAssetLocation(val: string) {
    if (val) {
      const value = JSON.parse(val);
      return value[0].label;
    }
    return '';
  }
  onClickOpen() {
    this.dialog.open(this.detailsDialog);
  }
}
